/* eslint react/prop-types: 0 */
import React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import ListItemIcon from '@mui/material/ListItemIcon';

import { mapIconListForGoogleMap } from '../../../consts/mapIconList';
import { Text } from '../../../components/1elements';

import './styles.scss';

const MarkerListEditor = ({
  options,
  selectedRow,
  setSelectedRow,
  className,
  onEditMode,
  excludeKeys = []
}) => {
  const onClickHandler = (option) => {
    if (option === selectedRow) {
      setSelectedRow(null);
    } else {
      setSelectedRow(option);
    }
  };

  if (!Object.keys(options).length) {
    return (
      <Text className="EditorList-errorMessage" type={'p'}>
        We couldn&apos;t find any results.
      </Text>
    );
  }

  return (
    <List className={`EditorList-root ${className}`}>
      {Object.entries(options).map(([key, value]) => {
        if (excludeKeys.includes(key)) return null;

        const fillColor = value.color || '#333';
        const style = value.style || 'circle';
        const iconIdx = value.icon || 0;

        return (
          <ListItem
            key={key}
            secondaryAction={
              onEditMode ? (
                <IconButton
                  aria-label={`Edit ${value.name}`}
                  edge="end"
                  onClick={() => {
                    onClickHandler(key);
                  }}
                >
                  <EditIcon
                    fontSize={'small'}
                    className={
                      key === selectedRow
                        ? 'EditorList-selectedRow'
                        : 'EditorList-penIcon'
                    }
                  />
                </IconButton>
              ) : null
            }
            disablePadding
            divider
          >
            <ListItemIcon>
              <img
                className="EditorList-itemIcon"
                alt="marker"
                src={mapIconListForGoogleMap(fillColor, style)[iconIdx]}
              />
            </ListItemIcon>
            <ListItemText primary={value.name} />
          </ListItem>
        );
      })}
    </List>
  );
};

export default MarkerListEditor;
